module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-grid justify-content-end"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success addNewBtn btn-btm-0",
    attrs: {
      "icon": "pi pi-plus",
      "label": "NEW"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAddDialog.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialogs', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Product",
      "visible": _vm.addDisplayBasic,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.addDisplayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button",
          attrs: {
            "label": _vm.editing ? 'Update' : 'Add'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addProduct.apply(null, arguments)
            }
          }
        }), _vm._v(" "), (!_vm.editing) ? _c('Button', {
          staticClass: "p-button-raised p-button-primary",
          attrs: {
            "label": "Add & New"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addAndNewProduct.apply(null, arguments)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addCancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "itemCode"
    }
  }, [_vm._v("Code"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "itemCode"
    },
    model: {
      value: (_vm.itemCode),
      callback: function($$v) {
        _vm.itemCode = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "itemCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "unit"
    }
  }, [_vm._v("Unit"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "unit"
    },
    model: {
      value: (_vm.unit),
      callback: function($$v) {
        _vm.unit = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "unit"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "marketpurchaseprice"
    }
  }, [_vm._v("Market Purchase Rate")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "marketpurchaseprice"
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.marketpurchaseprice),
      callback: function($$v) {
        _vm.marketpurchaseprice = $$v
      },
      expression: "marketpurchaseprice"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "marketSellingPrice"
    }
  }, [_vm._v("Market Sales Rate")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "marketSellingPrice"
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.marketSellingPrice),
      callback: function($$v) {
        _vm.marketSellingPrice = $$v
      },
      expression: "marketSellingPrice"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "sellingPrice"
    }
  }, [_vm._v("Sales Rate")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "sellingPrice"
    },
    model: {
      value: (_vm.sellingprice),
      callback: function($$v) {
        _vm.sellingprice = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "sellingprice"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "commissionrate"
    }
  }, [_vm._v("Commission Rate")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "commissionrate"
    },
    model: {
      value: (_vm.commissionrate),
      callback: function($$v) {
        _vm.commissionrate = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "commissionrate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "discountRate"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "discountRate"
    },
    model: {
      value: (_vm.discountRate),
      callback: function($$v) {
        _vm.discountRate = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "discountRate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDate"
    }
  }, [_vm._v("Sales Started Date")]), _vm._v(" "), _c('InputMask', {
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "startDate"
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "status1"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('RadioButton', {
    attrs: {
      "id": "status1",
      "name": "ACTIVE",
      "value": "ACTIVE"
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status1"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('RadioButton', {
    attrs: {
      "id": "status2",
      "name": "INACTIVE",
      "value": "INACTIVE"
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status2"
    }
  }, [_vm._v("Inactive")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('Textarea', {
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "rows": "3"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7a82f20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/crmDialog/crmProductDetailsDialog.vue
// module id = 2376
// module chunks = 0